import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout Components
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MusicPlayer } from "@/components/ui/MusicPlayer";

// Pages
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import GalleryPage from "@/pages/GalleryPage";
import ReviewsPage from "@/pages/ReviewsPage";
import PerformancesPage from "@/pages/PerformancesPage";
import AboutPage from "@/pages/AboutPage";

function App() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/book" element={<BookingPage />} />
                    <Route path="/gallery" element={<GalleryPage />} />
                    <Route path="/reviews" element={<ReviewsPage />} />
                    <Route path="/performances" element={<PerformancesPage />} />
                    <Route path="/about" element={<AboutPage />} />
                </Routes>
                <Footer />
                <MusicPlayer />
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
